import { render, staticRenderFns } from "./ListBuyerCampaigns.vue?vue&type=template&id=2d28a17a&scoped=true"
import script from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"
export * from "./ListBuyerCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ListBuyerCampaigns.vue?vue&type=style&index=0&id=2d28a17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d28a17a",
  null
  
)

export default component.exports